module.exports = __webpack_public_path__ + "img/grey_034.6b627c27.png";